/// <reference path="../../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor()
    @Serenity.Decorators.element("<div/>")
    export class ClientFunctionTriggerParametersEditor extends Common.GridEditorBase<ClientFunctionTriggerParameter> {
        protected getColumnsKey() { return "Workflow.ClientFunctionTriggerParameters" };
        protected getDialogType() { return ClientFunctionTriggerParameterDialog; }

        protected getAddButtonCaption() {
            return "Add Parameter";
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].icon = 'fa-plus';

            return buttons;
        }

        public updateParameters: () => void;

        validateEntity(row: ClientFunctionTriggerParameter, id) {
            row.EditorType = Q.trimToNull(row.EditorType);
            row.Type = Q.toId(row.Type);
            return true;
        }
    }
}